<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        
        <Toolbar class="p-mb-4">
          <template slot="left">
            <Button
              label="New Note"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="openNew"
            />
          </template>

          <template slot="right">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters['global']"
                placeholder="Global Search"
              />
            </span>
          </template>
        </Toolbar>
      </div>
    </div>

    <NotesTable
      style="width: 100%;"
      :notes="notes"
      :loading="loading"
      :filters="filters"
      @edit-note="editNote"
      @delete-note="confirmDeleteNote"
    />

    <NoteForm
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="['enquiry', 'Customer']"
      @close="noteDialog = false"
      @noteSaved="noteSaved"
    />

  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import CustomerService from "@/service/CustomerService";

import NoteForm from '../../universalComponents/note/NoteForm'
import NotesTable from '../../universalComponents/note/NotesTable'

export default {
  components: {
    NoteForm,
    NotesTable
  },
  props: ["opportunity"],
  data() {
    return {
      opportunityService: new OpportunityService(),
      customerService: new CustomerService(),
      notes: null,
      note: {},
      noteDialog: false,
      selectedNotes: null,
      filters: {},
      reloadNoteForm: 0, // this is not the key
      requesting: false,
      selectedRow: null,
      noteDetails: ''
    };
  },
  computed: {
    loading() {
      if (this.notes && this.notes[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted() {
    this.getOpportunityNotes()
  },
  methods: {
    confirmDeleteNote(data) {
      
      if (data && data.custNoteId) {
        this.customerService
          .deleteNoteDB(data.custNoteId)
          .then(() => {
            this.getOpportunityNotes()
          })
          .catch(error => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while deleting note ${data.noteHeader}`,
              life: 5000,
            })
          })
      }
    },
    getOpportunityNotes() {
      this.requesting = true
      this.opportunityService
        .getOpportunityNotes(this.opportunity.oppId)
        .then((data) => {
          this.requesting = false
          this.notes = data
        })
        .catch(err => {
          this.requesting = false
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer notes",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "opportunityNotes/{oppId}"'
          })
        })
    },
    openNew() {
      this.note = {
        enquiry: this.opportunity,
        customer: this.opportunity.customer
      };
      this.noteDialog = true;
      this.reloadNoteForm++
    },
    editNote(note) {
      this.note = { ...note, enquiry: this.opportunity };
      
      this.noteDialog = true;
      this.reloadNoteForm++
    },
    noteSaved() {
      this.noteDialog = false;
      this.note = {};
      this.getOpportunityNotes()
    }
  }
};
</script>

<style scoped lang="scss">
.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
